import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()

export class UpdateService {
  private updateSubject = new BehaviorSubject<boolean>(false);

  get update$() {
    return this.updateSubject.asObservable();
  }

  notifyUpdate() {
    this.updateSubject.next(true);
  }

  clearNotification() {
    this.updateSubject.next(false);
  }
}


// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/modals/report.service.ts